const harvestBowlBanner = require('./harvest-bowl-banner.png');
const wrapBanner = require('./wrap-banner.png');

export const assets = {
  harvestBowlBanner,
  wrapBanner,
};
